

export const isEntityId = (val: string) => {
    
    return val.length === 24;
    };
  
  